














import _ from 'lodash'
import { Component } from 'vue-property-decorator'
import BaseInput from '@/services/BaseInput'

@Component
export default class Description extends BaseInput {}
